<script setup lang="ts">
import { computed } from 'vue'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@collector/shared-ui'
import type { SubParticipant } from '@collector/sportsapi-types'

import type { LineupConfig } from '../../../interfaces/LineupConfig'
import type { LineupModel } from '../../../interfaces/LineupModel'
import { cloneWithKey } from '../../../utils/model.utils'
import FoundPlayer from './FoundPlayer/FoundPlayer.vue'
import NewPlayer from './NewPlayer/NewPlayer.vue'

type Props = {
  config: LineupConfig
}
const props = defineProps<Props>()

// state
const lineup = defineModel<LineupModel>({ required: true })

// computed
const defaultTab = computed(() =>
  props.config.addPlayer.isSearchAllowed ? 'search' : 'add',
)

// methods
function handleAdd(key: PropertyKey, player: Partial<SubParticipant>): void {
  const updatedLineup = cloneWithKey(lineup, key)
  updatedLineup[key].push(player as SubParticipant)
  lineup.value = updatedLineup
}
</script>

<template>
  <Tabs
    :key="defaultTab"
    :defaultValue="defaultTab"
  >
    <TabsList>
      <TabsTrigger
        v-if="config.addPlayer.isSearchAllowed"
        value="search"
      >
        Search for a player
      </TabsTrigger>
      <TabsTrigger value="add">Add new player</TabsTrigger>
    </TabsList>
    <TabsContent
      v-if="config.addPlayer.isSearchAllowed"
      value="search"
    >
      <FoundPlayer
        :config
        :lineup
        @add="(key, player) => handleAdd(key, player)"
      />
    </TabsContent>
    <TabsContent value="add">
      <NewPlayer
        :config
        :lineup
        @add="(key, player) => handleAdd(key, player)"
      />
    </TabsContent>
  </Tabs>
</template>
